var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('small',[_vm._v("Select report")]),_c('vue-single-select',{attrs:{"classes":{
      input: 'form-control',
      dropdown: 'dropdown p-0',
    },"options":_vm.reports.data,"optionLabel":"name"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }